<svg
  fill="#2a66c6"
  height="24px"
  width="24px"
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 512 512"
  xml:space="preserve"
  stroke="#2a66c6"
  ><g id="SVGRepo_bgCarrier" stroke-width="0" /><g
    id="SVGRepo_tracerCarrier"
    stroke-linecap="round"
    stroke-linejoin="round"
  /><g id="SVGRepo_iconCarrier">
    <g>
      <g>
        <path
          d="M171.963,46.681c-22.895,0-36.573,39.645-36.573,77.973c0,2.662,1.241,5.17,3.347,6.787 c1.515,1.164,3.355,1.772,5.212,1.772c0.736,0,1.472-0.094,2.2-0.282c14.114-3.749,29.477-6.753,45.637-8.927 c4.254-0.565,7.421-4.194,7.421-8.482C199.198,69.842,190.04,46.681,171.963,46.681z M152.911,113.621 c2.208-29.777,12.941-49.822,19.052-49.822c2.525,0,9.167,10.707,10.031,44.319C171.946,109.649,162.215,111.481,152.911,113.621z "
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M423.547,313.046c-48.401,17.212-107.048,29.032-164.256,27.654c-60.067,1.438-121.769-11.769-171.488-30.479 c-3.252-1.224-6.496,1.686-5.623,5.05l16.271,62.746c0.325,1.241,1.155,2.277,2.311,2.833 c41.905,19.985,98.352,31.78,158.744,31.78c54.247,0,108.965-11.281,150.99-29.409c1.232-0.522,2.123-1.592,2.456-2.893 l16.125-62.207C429.94,314.792,426.782,311.899,423.547,313.046z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M460.642,185.962c0-30.838-36.453-57.071-100.003-71.981c-35.854-8.414-78.204-12.265-120.151-11.041 c-2.294,0.068-4.177-1.703-4.322-3.997C232.715,42.547,205.754,0,171.963,0C123.186,0,99.922,66.581,98.15,131.27 c-0.043,1.558-0.984,2.961-2.379,3.655c-29.862,14.756-44.413,31.489-44.413,51.046c0,2.191-0.171,9.757,0.274,11.486 l22.587,87.105c0.334,1.292,1.224,2.362,2.456,2.884c50.104,21.483,117.267,37.711,182.632,36.145 c62.472,1.566,126.006-12.975,175.083-32.815c1.267-0.514,2.2-1.592,2.542-2.919l23.435-90.409 C460.813,195.719,460.642,188.161,460.642,185.962z M343.94,258.944c-12.787,6.103-37.822,8.936-50.592,8.936 c-4.733,0-8.559-3.826-8.559-8.559c0-51.286,13.677-81.91,36.564-81.91c23.991,0,27.235,37.36,27.235,73.907 C348.587,254.536,346.85,257.558,343.94,258.944z M390.997,231.016c-2.67,1.01-5.546-0.89-5.794-3.732 c-4.759-54.607-31.566-96.554-63.842-96.554c-38.986,0-70.021,50.472-73.582,117.096c-0.12,2.302-2.114,4.194-4.425,4.134 c-103.692-2.542-174.886-35.922-174.886-65.99c0-13.823,14.833-27.269,44.053-39.936c1.601-0.693,2.67-2.268,2.653-4.014 c-0.625-59.999,19.326-124.902,56.789-124.902c25.728,0,47.468,43.112,47.468,94.149v0.762c0,2.345,0.967,4.596,2.679,6.222 c1.712,1.609,4.014,2.465,6.351,2.32c9.038-0.496,18.308-0.745,27.534-0.745c35.708,0,70.535,3.749,100.74,10.827 c52.723,12.368,86.797,34.082,86.797,55.317C443.532,201.924,423.795,218.571,390.997,231.016z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M399.359,406.168c-40.998,14.833-90.238,23.58-139.846,23.58c-54.889,0.009-105.875-9.064-147.181-25.129 c-3.27-1.267-6.565,1.618-5.683,5.016l10.468,40.356C128.646,486.503,185.76,512,256.004,512 c72.88,0,128.728-25.044,139.007-62.438l9.937-38.336C405.813,407.88,402.612,404.995,399.359,406.168z"
        />
      </g>
    </g>
  </g></svg
>
